export default "/images/edit-icon.svg?6dc10ef002c340e8cca11d59bd8bbd13";